var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.objectType)?_c('div',[(_vm.showConstructor)?_c('api-method-interface',{attrs:{"prefix":("new " + (_vm.objectType.name)),"params":_vm.constructorType.params}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }